import tippy from 'tippy.js';
/*! purgecss start ignore */
import 'tippy.js/dist/tippy.css';
/*! purgecss end ignore */

tippy('.tooltip', {
  theme: 'wila',
  duration: 200,
  interactive: true,
  placement: 'top',
  content(reference) {
    const id = reference.getAttribute('data-template');
    const template = document.getElementById(id);
    return template.innerHTML;
  },
  allowHTML: true,
  popperOptions: {
    strategy: 'fixed',
    modifiers: [
      {
        name: 'flip',
        enabled: false
      }
    ]
  },
  maxWidth: 440
});

tippy('#tooltip-simple', {
  theme: 'wilasimple',
  duration: 200,
  interactive: true,
  placement: 'left',
  allowHTML: true,
  popperOptions: {
    modifiers: [
      {
        name: 'flip',
        enabled: false
      }
    ]
  },
  maxWidth: 440
});
